/**
 * A component dragged from the tools panel to the canvas. A drag carries only a
 * marker; what to add lives here between dragstart and drop.
 */

import { clamp } from './editing'
import type { LayoutElement } from './types'

export const TOOL_MIME = 'application/x-qms-tool'

export type Point = { x: number; y: number }

let carried: ((at: Point) => void) | null = null

export function carry(add: (at: Point) => void): void {
  carried = add
}

export function dropCarried(at: Point): boolean {
  const add = carried
  carried = null
  if (!add) return false
  add(at)
  return true
}

export function dropDone(): void {
  carried = null
}

/** Whether a drag over the canvas is one of ours. */
export function isToolDrag(types: readonly string[]): boolean {
  return types.includes(TOOL_MIME)
}

/** The element centred on the point, kept on the canvas. */
export function centreOn(el: LayoutElement, at: Point, canvas: { width: number; height: number }): LayoutElement {
  return clamp({ ...el, x: Math.round(at.x - el.w / 2), y: Math.round(at.y - el.h / 2) }, canvas)
}
